import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Medal } from "lucide-react";
import { getHubLeaderboard } from "@/api";
import { short } from "./HubCard";

const BADGE = { Gold: "text-amber-300 border-amber-400/50", Silver: "text-slate-200 border-slate-300/40", Bronze: "text-orange-300 border-orange-400/40", Inferno: "text-red-300 border-red-500/50" };

export function CreatorLeaderboard() {
  const [period, setPeriod] = useState("week");
  const [rows, setRows] = useState(null);
  useEffect(() => { setRows(null); getHubLeaderboard(period).then(setRows).catch(() => setRows([])); }, [period]);
  return (
    <div className="card-tile" data-testid="creator-leaderboard">
      <div className="flex items-center gap-2">
        <Trophy className="text-amber-400" size={20} />
        <h2 className="font-display text-xl font-bold flex-1">Top Creators</h2>
        {["week", "month"].map((p) => (
          <button key={p} onClick={() => setPeriod(p)} data-testid={`leaderboard-period-${p}`}
            className={`chip transition-colors ${period === p ? "border-orange-500 text-orange-300" : ""}`}>{p === "week" ? "Weekly" : "Monthly"}</button>
        ))}
      </div>
      <div className="mt-4 space-y-2">
        {rows === null && <div className="text-sm text-slate-500">Loading…</div>}
        {rows?.length === 0 && <div className="text-sm text-slate-500" data-testid="leaderboard-empty">No creator earnings yet this {period}. Launch a hub and be the first.</div>}
        {rows?.map((r) => (
          <div key={r.creator} className="flex items-center gap-3 py-2 border-b border-white/5" data-testid={`leaderboard-row-${r.rank}`}>
            <span className="w-7 font-pixel text-xs text-slate-400">#{r.rank}</span>
            <div className="flex-1 min-w-0">
              <div className="font-mono text-sm">{short(r.creator)}</div>
              {r.top_hub && <Link to={`/hubs/${r.top_hub.slug}`} className="text-xs text-cyan-400 hover:underline truncate block">{r.top_hub.name}</Link>}
              <div className="flex flex-wrap gap-1 mt-1">
                {r.badges.map((b) => <span key={b} className={`chip text-[10px] py-0.5 ${BADGE[b] || ""}`}><Medal size={10} /> {b}</span>)}
              </div>
            </div>
            <span className="font-mono text-orange-300 text-sm" data-testid={`leaderboard-earned-${r.rank}`}>{r.earned.toLocaleString()} FLAME</span>
          </div>
        ))}
      </div>
    </div>
  );
}
